import React from "react";

const MessageA3s= (props) => {
  const message = props?.item;

  const steps = message
    .split(/<br\s*\/?>/)
    .map((item) => item.trim())
    .filter((item) => item.length > 0);

  return (
    <div className="chat-text">
      {steps.map((step, index) => (
        <div key={index}>
          <div
            className="volte-text"
            style={{
              color: "rgba(225, 0, 146, 1)",
              fontWeight: 600,
              marginTop: "12px",
            }}
          >
            Step {index + 1}
          </div>
          <div style={{ marginBottom: index === steps?.length - 1 ? "12px" : 0 }} className="volte-text">  {step}</div>
        </div>
      ))}
    </div>
  );
};

export default MessageA3s;
